export default __webpack_public_path__ + "static/media/funds__distributions-portfolio.01564ce9.png";